import { useTranslation } from "react-i18next";
import { CustomTriggerTooltip } from "../../basic/Tooltip";
import { FaSortDown, FaSortUp } from "react-icons/fa6";
import { css } from "../../../../../styled-system/css";

const SortIcon = ({ sortBy, setSortBy }) => {
  const { t } = useTranslation(["common"]);
  return (
    <CustomTriggerTooltip
      toolTip={
        sortBy === "alphaAscending" ?
          t(($) => $.common["Sort alphabetically ascending"])
        : t(($) => $.common["Sort alphabetically descending"])
      }
      placement="top"
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          sortBy === "alphaAscending" ? setSortBy("alphaDescending") : setSortBy("alphaAscending");
        }}
        className="btn-round btn-icon"
      >
        {sortBy === "alphaAscending" ?
          <FaSortUp
            className={css({
              color: "grey",
              display: "inline",
              cursor: "pointer",
            })}
          />
        : <FaSortDown
            className={css({
              color: "grey",
              display: "inline",
              cursor: "pointer",
            })}
          />
        }
      </button>
    </CustomTriggerTooltip>
  );
};

export default SortIcon;
